import React from 'react';
import { Link } from 'react-router-dom';
import { FadeIn } from './FadeIn';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-28 pb-32" data-id="element-108">
      {/* Background Elements */}
      <div className="absolute inset-0 z-0" data-id="element-109">
        <div className="absolute inset-0 bg-cognarch-white" data-id="element-110" />
        <div className="absolute inset-0 bg-grid-pattern bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_80%_60%_at_50%_40%,#000_40%,transparent_100%)] opacity-30" data-id="element-111" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center flex flex-col items-center" data-id="element-112">
        <FadeIn delay={0.1} direction="down" data-id="element-113">
          <p className="text-cognarch-charcoal uppercase tracking-[0.3em] text-xs md:text-sm font-medium mb-8" data-id="element-114">
            The First True Political System of the 21st Century
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-115">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif font-medium leading-[1.1] tracking-tight mb-8 text-balance text-cognarch-black" data-id="element-116">
            Cognarchism
          </h1>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-117">
          <p className="text-2xl md:text-3xl font-serif text-cognarch-charcoal/80 mb-8 max-w-4xl text-balance" data-id="element-118">
            A political order built around competence, judgment, and civic
            development
          </p>
        </FadeIn>

        <FadeIn delay={0.7} data-id="element-119">
          <p className="text-base md:text-lg text-cognarch-gray max-w-2xl mx-auto mb-4 leading-relaxed" data-id="element-120">
            Rather than organizing society around ideology, popularity, or
            inherited authority, Cognarchism aligns power, opportunity, and
            responsibility with demonstrated reasoning, self-mastery, and
            resistance to manipulation.
          </p>
          <p className="text-base md:text-lg text-cognarch-gray max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-121">
            At the center of the model is the Neurocognitive Civic Judgment
            Index (NCJI), an AI-powered system designed to assess and strengthen
            the qualities most essential to sound citizenship.
          </p>
        </FadeIn>

        <FadeIn delay={0.9} className="flex flex-col sm:flex-row gap-6 items-center justify-center w-full sm:w-auto" data-id="element-122">
          <Link to="/charter" className="w-full sm:w-auto px-8 py-4 bg-cognarch-black text-white font-medium tracking-wide hover:bg-cognarch-charcoal transition-all duration-300 transform hover:-translate-y-0.5 text-center" data-id="element-123">
            Read the Manifesto
          </Link>
          <Link to="/overview" className="w-full sm:w-auto px-8 py-4 border border-cognarch-charcoal text-cognarch-charcoal font-medium tracking-wide hover:bg-cognarch-charcoal hover:text-white transition-all duration-300 text-center" data-id="element-124">
            Explore the Framework
          </Link>
        </FadeIn>
      </div>
    </section>;
}